export default __webpack_public_path__ + "static/media/About-Eligibility-1.83fcaea8.jpg";